import User from './user.js';
import { pushDataLayerEvent } from './datalayer.js';

/**
 * Remove products' cards based on their prestamp and provincial
 * exclusion data, and the visitor's province (from the age gate).
 *
 * This function is called once on ready (see below) to remove
 * already-rendered cards from ANY template (PLP, PDP, search
 * drawer, search results, etc.) and can be imported and used
 * in modules such as search-drawer.js where this removal should
 * occur again after each Ajax request.
 *
 * Refer to snippets/product.card.liquid for more information.
 */
export default function removeExcludedCards($ancestor) {
  (($) => {
    if (!$ancestor) $ancestor = $(document);

    const $productCards = $ancestor.find('.product__card');

    if (User.exists() && $productCards.length) {
      let provinceCode = User.getProvince();
      if (provinceCode) {
        provinceCode = provinceCode.toUpperCase();
        $productCards.each((index, element) => {
          const $productCard = $(element);
          const prestamp = $productCard.data('prestamp');
          const provincialExclusion = $productCard.data('province-exclusion');
  
          if (
            (prestamp && prestamp.toUpperCase() !== provinceCode) ||
            (provincialExclusion && provincialExclusion.toUpperCase().indexOf(provinceCode) !== -1)
          ) {
            $productCard.remove();
          }
        });
      }
    }
  })(jQuery);
}

(($) => {
  $(() => {
    removeExcludedCards();

    /**
     * Fire data layer events for clicks on product cards anywhere
     * they appear (e.g. the PLP, PDP, etc.). Position is based on
     * the default order of cards, or their adjusted order (using
     * the CSS order property) following filtering/sorting.
     */
    $('.product__card').on('click', '.card-body > a', (e) => {
      const $card = $(e.delegateTarget);

      let position = Number($card.data('index'));
      const order = Number($card.css('order'));

      if (order !== 0 && order !== position) position = order;

      pushDataLayerEvent({
        event: 'action',
        actionName: 'product clickthrough',
        attributes: {
          productPosition: position,
          productsDisplayed: $card.siblings().filter(':visible').length + 1,
        },
      });
    });
  });
})(jQuery);
